module.exports = __webpack_public_path__ + "static/media/iron_workers_color.c316ef1f.png";